const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

export function normalizePanNumber(value: string | null | undefined): string {
  return (value || "").trim().toUpperCase();
}

export function isValidPanNumber(value: string | null | undefined): boolean {
  const normalized = normalizePanNumber(value);
  if (!normalized) return false;
  return PAN_REGEX.test(normalized);
}
